export default {"src":"/_next/static/media/Handshake.4a2cf11e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};